<template>
  <v-dialog max-width="1200px" v-model="inDialog" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('gameId')"
                  v-model.trim="item.gameId"
                  name="className"
                  v-validate="'required'"
                  maxLength="500"
                  :error-messages="errors.first('gameId')"
                  :data-vv-as="$t('gameId')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('audioUrlVn')"
                  v-model.trim="item.audioUrlVn"
                  name="audioUrlVn"
                  v-validate="''"
                  maxLength="500"
                  :error-messages="errors.first('audioUrlVn')"
                  :data-vv-as="$t('audioUrlVn')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-text-field
                  type="text"
                  :label="$t('audioUrlEn')"
                  v-model.trim="item.audioUrlEn"
                  name="audioUrlEn"
                  v-validate="''"
                  maxLength="500"
                  :error-messages="errors.first('audioUrlEn')"
                  :data-vv-as="$t('audioUrlEn')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-checkbox
                  type="text"
                  :label="$t('isMergeRound')"
                  v-model.trim="item.isMergeRound"
                  name="isMergeRound"
                  v-validate="''"
                  maxLength="500"
                  :error-messages="errors.first('isMergeRound')"
                  :data-vv-as="$t('isMergeRound')"
              ></v-checkbox>
            </v-flex>
            <v-flex xs6 sm6 md6 lg6 xl6 style="padding: 10px">
              <v-checkbox
                  type="text"
                  :label="$t('isUsingVolumeDefault')"
                  v-model.trim="item.isUsingVolumeDefault"
                  name="isUsingVolumeDefault"
                  v-validate="''"
                  maxLength="500"
                  :error-messages="errors.first('isUsingVolumeDefault')"
                  :data-vv-as="$t('isUsingVolumeDefault')"
              ></v-checkbox>
            </v-flex>

          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";
import moment from "moment/moment";

export default {
  name: "school-create-form",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },


  },
  data: () => {
    return {
      areaStatus: areaContants.areaStatus,
      item: {
        gameId: "",
        audioUrlVn: "",
        audioUrlEm: "",
        isMergeRound: false
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        if (value !== null) {
          this.item =  Object.assign({}, value);
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = Object.assign({}, {"isActive": 1});
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/schoolGameTutorial/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
  },
};
</script>
